var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CheckboxIcon',{attrs:{"checked":_vm.value,"size":_vm.size},nativeOn:{"click":function($event){return _vm.toggle.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }